import {
  StyledTextField,
  StyledTextFieldProps,
} from "@redotech/redo-web/styled-text-field";
import { memo } from "react";

export const ReturnAppTextField = memo(
  ({
    value,
    ...props
  }: {
    value: string;
  } & StyledTextFieldProps) => {
    return (
      <StyledTextField
        fontFamily="var(--return-app-body-font-family)"
        value={value}
        {...props}
      />
    );
  },
);
